'use client';

import { ThemeProvider } from '@campaign-manager/app/ui/react/context/ThemeProvider';
import { SpinnerModal } from '@campaign-manager/react/components';

export default function Loading() {
  return (
    <ThemeProvider projectSettings={undefined}>
      <SpinnerModal />
    </ThemeProvider>
  );
}
